import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "container mx-auto mt-10 max-w-screen-2xl px-0" }
const _hoisted_3 = {
  key: 2,
  class: "text-center"
}
const _hoisted_4 = {
  key: 3,
  class: "block h-8"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-10 flex w-full items-center justify-center text-center"
}

import { computed, ref, onMounted, nextTick, watch } from "vue";
import { storeToRefs } from "pinia";

import { getGlobalTranslation } from "~/js/composables/translations";

import { Translations } from "~/js/interfaces/translations";
import { Category } from "~/js/interfaces/knowledge-hub";

import { animateOverviewGridItems } from "~/js/utils/animation";

import { useSearchStore } from "~/js/store/search";

import Grid from "~/vue/organisms/grids/GridLandings.vue";
import GridSkeleton from "~/vue/organisms/grids/GridSkeleton.vue";
import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import NavigationPagination from "~/vue/organisms/navigations/NavigationPagination.vue";
import FilterSearchResults from "~/vue/organisms/filters/FilterSearchResults.vue";

interface Props {
	filterable?: boolean;
	industries?: Array<Category> | null;
	paginated?: boolean;
	solutions?: Array<Category> | null;
	translations?: Translations | null;
	/** Passed to search filters: Typesense `type` slugs always shown first (see `SEARCH_RESULTS_CANONICAL_TYPE_SLUGS`). */
	canonicalTypeSlugs?: Array<string> | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewSearch',
  props: {
    filterable: { type: Boolean, default: true },
    industries: { default: null },
    paginated: { type: Boolean, default: true },
    solutions: { default: null },
    translations: { default: null },
    canonicalTypeSlugs: { default: null }
  },
  setup(__props: any) {

const props = __props;
const searchStore = useSearchStore();
const { cards, loading, pagination } = storeToRefs(searchStore);
const grid = ref(null);
const visibleCards = computed(() => {
	return (cards.value ?? []).filter((item: any) => {
		return !(item.document?.type === "file" && item.document?.consent);
	});
});

const onChangePage = (page: number) => {
	if (grid.value) {
		window.scrollTo({
			top: grid.value.getBoundingClientRect().top + window.scrollY + -200,
			left: 0,
			behavior: "smooth",
		});
	}

	nextTick(() => {
		searchStore.setPagination(page);
	});
};

watch(cards, () => {
	if (cards.value && cards.value.length > 0) {
		nextTick(() => {
			animateOverviewGridItems();
		});
	}
});

onMounted(async () => {
	await searchStore.fetch();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.filterable)
        ? (_openBlock(), _createBlock(FilterSearchResults, {
            key: 0,
            translations: __props.translations,
            industries: __props.industries ?? [],
            solutions: __props.solutions ?? [],
            "canonical-type-slugs": __props.canonicalTypeSlugs
          }, null, 8, ["translations", "industries", "solutions", "canonical-type-slugs"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "grid",
        ref: grid
      }, [
        (_unref(loading))
          ? (_openBlock(), _createBlock(GridSkeleton, {
              key: 0,
              size: _unref(pagination).itemsPerPage
            }, null, 8, ["size"]))
          : _createCommentVNode("", true),
        (_unref(cards))
          ? (_openBlock(), _createBlock(Grid, {
              key: 1,
              animate: true,
              items: visibleCards.value.map((item) => item.document)
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(cards) && _unref(cards).length === 0 && !_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(TextH3, { utilities: "inline-flex items-center space-x-4 mb-4" }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-lg" }, [
                      _createElementVNode("i", { class: "far fa-files" })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(getGlobalTranslation)("No results")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(TextBody, { utilities: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Make your search filter less specific")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true)
      ], 512),
      (!_unref(loading) && _unref(pagination).totalPages > 1 && __props.paginated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(cards) && !_unref(loading) && _unref(pagination).totalPages > 1)
              ? (_openBlock(), _createBlock(NavigationPagination, {
                  key: 0,
                  current: _unref(pagination).current,
                  "total-items": _unref(pagination).totalResults,
                  "total-pages": _unref(pagination).totalPages,
                  "items-per-page": _unref(pagination).itemsPerPage,
                  onChangePage: onChangePage
                }, null, 8, ["current", "total-items", "total-pages", "items-per-page"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})